var spriteSheetId = 'vcp-icon-spritesheet-id';
var createSvgSpritesheetContainer = function () {
    if (document.getElementById(spriteSheetId)) {
        return;
    }
    var container = document.createElement('div');
    container.id = spriteSheetId;
    container.style.width = '0';
    container.style.height = '0';
    container.style.position = 'absolute';
    container.style.overflow = 'hidden';
    container.ariaHidden = 'true';
    document.body.appendChild(container);
    return container;
};
export default createSvgSpritesheetContainer;
